import datepicker from 'js-datepicker';

'use strict';
const DataPicker = {
	init: function() {
		const startDateInput = document.querySelector('.js-date-start');
		const endDateInput = document.querySelector('.js-date-end');
		const today = new Date();

		if (startDateInput) {
			const startDatePicker = datepicker(startDateInput, {
				minDate: today,
				onSelect: () => {
					endDateInput.value = startDateInput.value;
				}
			});
		}

		if (endDateInput) {
			const endDateInputPicker = datepicker(endDateInput);
		}

	},
};

export default DataPicker;
